var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"section"},[(_vm.showcase)?_c('div',[_c('PageHeader',{attrs:{"title":_vm.showcase.name,"isRed":true}}),_vm._v(" "),_c('ShowcaseCard',{attrs:{"showcase":_vm.showcase}})],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }